"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCardFieldWidthDefaultValue = exports.StripeCardFieldWidthUnit = exports.StripeCardFieldHeightUnit = exports.StripeCardFieldHeightValue = void 0;
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const useAppStateSelector_1 = __importDefault(require("../hooks/useAppStateSelector"));
const appStateSelectControlWidthValueById_1 = __importDefault(require("../shared/appStateSelectControlWidthValueById"));
const computeComplexUnit_1 = __importDefault(require("../ControlStyleFormaters/shared/computeComplexUnit"));
const useControlEventCallback_1 = __importDefault(require("../hooks/useControlEventCallback"));
exports.StripeCardFieldHeightValue = 50;
exports.StripeCardFieldHeightUnit = 'px';
exports.StripeCardFieldWidthUnit = '%';
exports.StripeCardFieldWidthDefaultValue = 90;
const ControlStripeCardFieldComponent = ({ controlId, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const widthValue = (0, useAppStateSelector_1.default)((0, appStateSelectControlWidthValueById_1.default)(controlId));
    const width = widthValue ? (0, computeComplexUnit_1.default)({
        value: widthValue,
        unit: exports.StripeCardFieldWidthUnit,
    }) : undefined;
    const height = (0, computeComplexUnit_1.default)({
        value: exports.StripeCardFieldHeightValue,
        unit: exports.StripeCardFieldHeightUnit,
    });
    const onCardChangeEventCallback = (0, useControlEventCallback_1.default)({
        controlId,
        eventKey: 'onCardChange',
    });
    const onCardCompleteEvent = (0, useControlEventCallback_1.default)({
        controlId,
        eventKey: 'onCardComplete',
    });
    return (react_1.default.createElement(Render.View, { style: {
            width,
            height,
        } },
        react_1.default.createElement(Render.StripeCardField, { onCardChange: (cardData) => {
                onCardChangeEventCallback === null || onCardChangeEventCallback === void 0 ? void 0 : onCardChangeEventCallback(cardData);
            }, onCardComplete: (cardData) => {
                onCardCompleteEvent === null || onCardCompleteEvent === void 0 ? void 0 : onCardCompleteEvent(cardData);
            } })));
};
exports.default = ControlStripeCardFieldComponent;
